<template>
  <div class="logs-searching">
    <section class="section">
      <div class="card">
        <div class="card-content">
          <div class="columns is-tablet">
            <div class="column">
              <b-field label="Products">
                <b-select placeholder="Select a product" v-model="filters.product_id">
                  <option
                      v-for="option in products"
                      :value="option.id"
                      :key="option.id">
                    {{ option.name }}
                  </option>
                </b-select>
              </b-field>
                <b-field label="Platforms">
                    <b-taginput
                        v-model="selectedPlatforms"
                        :data="filteredPlatforms"
                        autocomplete
                        open-on-focus
                        icon="label"
                        field="name"
                        placeholder="Add a platform"
                        @typing="queries.platform = $event">
                    </b-taginput>
                </b-field>
                <b-field label="Target (regexp)">
                    <b-input v-model="filters.target_name"/>
                </b-field>
            </div>
            <div class="column">
                <b-field label="MTR">
                    <b-taginput
                        v-model="selectedMtrNames"
                        :data="filteredMtrNames"
                        autocomplete
                        open-on-focus
                        icon="label"
                        field="name"
                        placeholder="Add a MTR"
                        @typing="queries.mtrName = $event">
                    </b-taginput>
                </b-field>
              <b-field label="Time interval">
                <div class="field">
                    <b-select expanded v-model="filters.time_interval">
                        <option
                            v-for="option in TIME_INTERVAL_OPTIONS"
                            :value="option.value.toString()"
                            :key="option.value">
                            {{ option.title }}
                        </option>
                    </b-select>
                  <b-datepicker
                      v-if="filters.time_interval === '-2'"
                      placeholder="Click to select..."
                      v-model="filters.dates"
                      icon="calendar-today"
                      range>
                  </b-datepicker>
                </div>
              </b-field>
            </div>
          </div>
          <h1 class="title">Logs search</h1>
          <b-field>
            <b-input placeholder="Search..."
                     expanded
                     v-model="filters.query"
                     type="textarea"
                     icon="magnify">
            </b-input>
            <p class="control">
              <b-button type="is-primary" :loading="isLoading" @click="onSearchClick">Search</b-button>
            </p>
          </b-field>
        </div>
      </div>


      <LogObject v-for="(log, index) in targetBuilds" :key="log.target" :log-object="log"></LogObject>
    </section>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import LogObject from '@/components/LogObject';
  import {LOGS_TIME_INTERVAL_OPTIONS, LOGS_PRODUCTS} from "@/utils/constants";
  import {formatDate, valueToArray, filterOptionsByQuery} from "@/utils/helpers";
  import filtersMixin from "@/utils/filtersMixin";
    export default {
        name: "LogsSearching",
        mixins: [filtersMixin],
        data() {
            return {
                isLoading: false,
                error: null,
                filters: {},
                TIME_INTERVAL_OPTIONS: LOGS_TIME_INTERVAL_OPTIONS,
                LOGS_PRODUCTS,

                queries: {
                    mtrName: '',
                    platform: '',
                    target_name: '',
                },
            }
        },
        computed: {
            ...mapGetters('Logs', [
                'logs',
                'targetBuilds',
            ]),
            ...mapGetters('Auth', [
                'hasAccess',
            ]),
        },
        methods: {
            ...mapActions('Logs', [
                'searchLogs',
            ]),
            ...mapActions('TestRuns', [
              'fetchMtrNames',
            ]),
            ...mapActions('Platforms', [
              'fetchPlatforms',
            ]),
            ...mapActions('TargetBuilds', [
                'fetchProducts',
            ]),
          setFiltersByQuery(query) {
            this.filters = {
              mtr_ids: valueToArray(query.mtr_ids),
              product_id: query.product_id == null ? "2" : query.product_id,
              time_interval: query.time_interval == null ? '10' : query.time_interval,
              dates: valueToArray(query.dates).map(item => new Date(item)),
              query: query.query || '',
              platform_ids: valueToArray(query.platform_ids),
              target_name: query.target_name || '',
            }
          },
          fetchData() {
            return [
                this.fetchPlatforms(),
                this.fetchMtrNames(),
                this.fetchProducts(),
            ];
          },
          async search() {
            if (!this.hasAccess) return;
            this.isLoading = true;
            const filters = Object.assign({}, this.filters, {
              dates: this.filters.dates.map(date => formatDate(date)),
            });
            try {
              await this.searchLogs(filters);
            } catch(message) {
              this.error = message;
            }
            this.isLoading = false;
          },
          clearData() {
          },
        },
        components: {
            LogObject,
        },
    }
</script>

<style scoped>

</style>